<template>
  <router-view />
</template>

<script>
export default {
  name: "business",
};
</script>